export const getStandardCurrency = (price: number): string => {
  // UX requirements want either no decimals or 2 decimals
  // https://stackoverflow.com/questions/49724537/intl-numberformat-either-0-or-two-fraction-digits
  const formatter = new Intl.NumberFormat('en-us', {
    style: 'currency',
    currency: 'USD',
  });

  return formatter.format(price);
};

// UX requirements want either no decimals or 2 decimals
// https://stackoverflow.com/questions/49724537/intl-numberformat-either-0-or-two-fraction-digits
export const getDynamicCurrency = (price: number): string => {
  // Round to two decimal places and check if the result is a whole number. If it is, return the price with no decimal places. If it is not, return the price with two decimal places.
  return (Math.round(price * 100) / 100) % 1 === 0
    ? wholeDollarFormat(price)
    : fractionFormat(price);
};

const wholeDollarFormat = (price: number): string => {
  const wholeDollar = new Intl.NumberFormat('en-us', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return wholeDollar.format(price);
};

export const fractionFormat = (price: number): string => {
  const fraction = new Intl.NumberFormat('en-us', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  });

  return fraction.format(price);
};
